import React from 'react';
import LoginComponent from '../components/Auth/Login';

const LoginPage: React.FC = () => {
  return <LoginComponent />;
};

export default LoginPage;